import { mapGetters } from "vuex";

import PRSettings from "./PR/PRSettings.js";
import PRTabData from "./PR/PRTabData.js";
import actionSettings from "./PR/actionSettings.js";
import mainInfoSettings from "./PR/mainInfoSettings.js";
import searchSettings from "./PR/searchSettings.js";

import ContractPRSettings from "./ContractPR/PRSettings.js";
import ContractPRTabData from "./ContractPR/PRTabData.js";
import ContractPRactionSettings from "./ContractPR/actionSettings.js";
import ContractPRmainInfoSettings from "./ContractPR/mainInfoSettings.js";


import POSettings from "./PO/POSettings.js";
import POTabData from "./PO/POTabData.js";
import POactionSettings from "./PO/actionSettings.js";
import POmainInfoSettings from "./PO/mainInfoSettings.js";

import vendorSettings from "./vendor/settings.js";
import vendorTabData from "./vendor/tabData.js";
import vendorActionSettings from "./vendor/actionSettings.js";
import vendorMainInfoSettings from "./vendor/mainInfoSettings.js";


import contractSettings from "./CONTRACT/settings.js";
import contractTabData from "./CONTRACT/tabData.js";
import contractActionSettings from "./CONTRACT/actionSettings.js";
import contractMainInfoSettings from "./CONTRACT/mainInfoSettings.js";


import grnSettings from "./grn/settings.js";
import grnTabData from "./grn/tabData.js";
import grnActionSettings from "./grn/actionSettings.js";
import grnMainInfoSettings from "./grn/mainInfoSettings.js";
 

import adjustmentSettings from "./adjustmentNotes/settings.js";
import adjustmentTabData from "./adjustmentNotes/tabData.js";
import adjustmentActionSettings from "./adjustmentNotes/actionSettings.js";
import adjustmentMainInfoSettings from "./adjustmentNotes/mainInfoSettings.js";

export const settingsMixin = {
    data: function () {
        return {
            //this determins if there are any additional tab to display
            tabDatas: [
                {
                    subject: "PR",
                    data: PRTabData
                },
                {
                    subject: "contractPR",
                    data: ContractPRTabData
                },
                {
                    subject: "PO",
                    data: POTabData
                },
                {
                    subject: "vendor",
                    data: vendorTabData
                },
                {
                    subject: "contract",
                    data: contractTabData
                },
                {
                    subject: "GRN",
                    data: grnTabData
                },
                {
                    subject: "adjustments",
                    data: adjustmentTabData
                },
            ],
            //this determines what data to display in the table
            pageSettings: [
                {
                    subject: "PR",
                    settings: PRSettings
                },
                {
                    subject: "contractPR",
                    settings: ContractPRSettings
                },
                {
                    subject: "PO",
                    settings: POSettings
                },
                {
                    subject: "vendor",
                    settings: vendorSettings
                },
                {
                    subject: "contract",
                    settings: contractSettings
                },
                {
                    subject: "GRN",
                    settings: grnSettings
                },
                {
                    subject: "adjustments",
                    settings: adjustmentSettings
                },
            ],
            //this will display if there are any buttons and status information to show
            actionSettings: [
                {
                    subject: "PR",
                    columnNameToCheckStatus: "poStatus",
                    settings: actionSettings
                },
                {
                    subject: "contractPR",
                    columnNameToCheckStatus: "prStatus",
                    settings: ContractPRactionSettings
                },
                {
                    subject: "PR",
                    columnNameToCheckStatus: "poStatus",
                    settings: actionSettings
                },
                {
                    subject: "PO",
                    columnNameToCheckStatus: "poStatus",
                    settings: POactionSettings
                },
                {
                    subject: "vendor",
                    columnNameToCheckStatus: "vendorStatus",
                    settings: vendorActionSettings
                },
                {
                    subject: "contract",
                    columnNameToCheckStatus: "contractStatus",
                    settings: contractActionSettings
                },
                {
                    subject: "GRN",
                    columnNameToCheckStatus: "poNumber",
                    settings: grnActionSettings
                },
                {
                    subject: "adjustments",
                    columnNameToCheckStatus: "status",
                    settings: adjustmentActionSettings
                },
            ],
            //this will display the main information record
            mainInfoSettings: [
                {
                    subject: "PR",
                    columnNameToCheckStatus: "prStatus",
                    settings: mainInfoSettings
                },
                {
                    subject: "contractPR",
                    columnNameToCheckStatus: "prStatus",
                    settings: ContractPRmainInfoSettings
                },
                {
                    subject: "PO",
                    columnNameToCheckStatus: "poStatus",
                    settings: POmainInfoSettings
                },
                {
                    subject: "vendor",
                    columnNameToCheckStatus: "vendorStatus",
                    settings: vendorMainInfoSettings
                },
                {
                    subject: "contract",
                    columnNameToCheckStatus: "contractStatus",
                    settings: contractMainInfoSettings
                },
                {
                    subject: "GRN",
                    columnNameToCheckStatus: "poNumber",
                    settings: grnMainInfoSettings
                },
                {
                    subject: "adjustments",
                    columnNameToCheckStatus: "status",
                    settings: adjustmentMainInfoSettings
                },
            ],
            searchSettings: [
                {
                    subject: "PR",
                    data: searchSettings
                },

            ],
        }
    },
    methods: {
        getSelectedSettingsValue(subject, key) {
            try {
                var filteredSettings = this.pageSettings.filter(f =>
                    f.subject == subject
                );
                //we set the user id on the fly
                var tempData = _.find(filteredSettings[0].settings, function (o) {
                    return o['key'] == key;
                });

                console.log('tempDatasss:', tempData);
                if (tempData != undefined) {
                    if (tempData.hasOwnProperty("tableSettings")) {
                        if (tempData.tableSettings.hasOwnProperty("filter")) {
                            if (tempData.tableSettings.filter.hasOwnProperty("userId")) {
                                tempData.tableSettings.filter.userId = this.getUserInfo.id;
                            }

                            if (tempData.tableSettings.filter.hasOwnProperty("branchId")) {
                                tempData.tableSettings.filter.branchId = this.getUserInfo.branch;
                            }

                            //for aditional data
                            if (tempData.tableSettings.hasOwnProperty("additionalData")) {
                                if (tempData.tableSettings.additionalData.hasOwnProperty("userId")) {
                                    tempData.tableSettings.additionalData.userId = this.getUserInfo.id;
                                }
                            }
                        }
                    }
                } else {
                    console.error(subject + " - " + key + " Has no Data!");
                    var data = [{ pageTitle: subject + " - " + key + " Has no Data!", tableSettings: null }];
                    return data;
                }
                return tempData;
            } catch (error) {
                console.log("error:", error);
                // this.$router.push({ name: 'page-error-404' });
            }

        },
        getActionSettings(subject, key) {
            try {
                var filteredActionSettings = this.actionSettings.filter(f =>
                    f.subject == subject
                );
                var tempData = _.filter(filteredActionSettings[0].settings, function (o) {
                    return o['key'] == key;
                });

                if (Object.entries(tempData).length > 1) {
                    var key = filteredActionSettings[0].columnNameToCheckStatus;
                    var currentStatus = this.getMainInfo[key];
                    tempData = _.find(tempData, function (o) {
                        return o['status'] == currentStatus;
                    });
                } else {
                    tempData = tempData[0];
                }

                //custom code for PR  ProcRejectedContract
                if (tempData.hasOwnProperty("status")) {
                    if (tempData.status == "Rejected Adjustment" || tempData.status == "HODRejectedContract" || tempData.status == "ProcRejectedContract" || tempData.status == "HOD Rejected Contract" || tempData.status == "Proc Rejected Contract" || tempData.status == "Rejected PR" || tempData.status == "Rejected Vendors" || tempData.status == "Rejected by Procurement" || tempData.status == "Rejected by HOD" || tempData.status == "PO Rejected By MD") {
                        if (this.getMainInfo.hasOwnProperty("reject_reason")) {
                            tempData.reject_reason = " Reason: " + this.getMainInfo['reject_reason']
                        } else if (this.getMainInfo.hasOwnProperty("rejectReason")) {

                            tempData.reject_reason = " Reason: " + this.getMainInfo['rejectReason']
                        }
                        else {
                            alert("Error: Rejected Object does not have rejected reason Field.");
                        }
                    }
                }


                //get the status of the current record  
                //we need to loop on Action button As well
                //for each button we need to defined the record ID to update when that buton is click
                //this record ID is defined when user click row of the table
                if (tempData.hasOwnProperty("actionButtons")) {
                    tempData.actionButtons.forEach(el => {
                        if (el.payLoad.hasOwnProperty("id")) {
                            el.payLoad.id = this.$store.state.profile.profileId
                        } else {
                            alert("pageStatus does not have id field")
                        }
                    });
                }



                return tempData;
            } catch (error) {
                console.log("error from getActionSettings:", error);
                // this.$router.push({ name: 'page-error-404' });
            }
        },
        getMainInfoSettings(subject, key) {
            try {
                var filteredmainInfoSettings = this.mainInfoSettings.filter(f =>
                    f.subject == subject
                );


                var tempData = _.filter(filteredmainInfoSettings[0].settings, function (o) {
                    return o['key'] == key;
                });

                if (Object.entries(tempData).length > 1) {
                    var key = filteredmainInfoSettings[0].columnNameToCheckStatus;
                    var currentStatus = this.getMainInfo[key];
                    console.log("currentStatus:", currentStatus);
                    tempData = _.find(tempData, function (o) {
                        return o['status'] == currentStatus;
                    });

                } else {
                    tempData = tempData[0];
                }


                //get the status of the current record  
                //we need to loop on Action button As well
                //for each button we need to defined the record ID to update when that buton is click
                //this record ID is defined when user click row of the table
                if (tempData != undefined) {
                    if (tempData.hasOwnProperty("actionButtons")) {
                        tempData.actionButtons.forEach(el => {
                            if (el.buttonType == "action") { //other type is relay which don't have this id
                                if (el.payLoad.hasOwnProperty("id")) {
                                    el.payLoad.id = this.$store.state.profile.profileId
                                } else {
                                    alert("payLoad does not have id field")
                                }
                            }

                        });
                    }
                }

                console.log("tempData in main info:", tempData);
                return tempData;
            } catch (error) {
                console.log("error from getMainInfoSettings:", error);
                // this.$router.push({ name: 'page-error-404' });
            }
        },

        getSettings(subject, key) {
            return this.getSelectedSettingsValue(subject, key);
        },
        getTabDatas(subject, viewOnly) {
            var tabData = this.tabDatas.filter(f =>
                f.subject == subject
            );

            console.log("tabData in get tab Data:", tabData);

            //loop through the data and update the filter id
            tabData[0].data.forEach(el => {
                console.log('eeeeee:',el);
                if (el.hasOwnProperty("tableSettings")) {
                    if (el.tableSettings.hasOwnProperty("filter")) {
                        if (el.tableSettings.filter.hasOwnProperty("pkId")) {
                            el.tableSettings.filter.pkId = this.$store.state.profile.profileId
                        } else {
                            alert("Tab Data filter does not have pkId ")
                        }

                        if (el.tableSettings.filter.hasOwnProperty("userId")) {
                            el.tableSettings.filter.userId = this.getUserInfo.id;
                        }

                        //if viewOnly is true we update some property 
                        if (viewOnly) {
                            el.tableSettings.showAddBtn = false;
                            el.tableSettings.showActionButton = false;
                            el.tableSettings.showEditBtn = false;
                        } 
                        
                        else {
                            if(el.tableSettings.filterEndpoint == "myContractPrItems"){
                                el.tableSettings.showAddBtn = true;
                                el.tableSettings.showActionButton = true;
                                el.tableSettings.showEditBtn = false;
                            }else{
                                el.tableSettings.showAddBtn = true;
                                el.tableSettings.showActionButton = true;
                                el.tableSettings.showEditBtn = true;
                            }
                          
                        }
                    }
                }

            });

            console.log("tabdata:", tabData[0].data);
            return tabData[0].data;
        },
        getSearch(subject, viewOnly) {
            var search = this.searchSettings.filter(f =>
                f.subject == subject
            );

            //loop through the data and update the filter id 
            if (search[0] != undefined) {
                return search[0].data;
            }

            return {}

        }


    },
    computed: {
        ...mapGetters({
            getUserInfo: "auth/getUserInfo",
            getMainInfo: "profile/getMainInfo"
        }),
        testData() {
            return "sdfsdf";
        }
    },
    created() {
    }
};